import { render, staticRenderFns } from "./RevisionTechnichalDetails.vue?vue&type=template&id=231524b4"
import script from "./RevisionTechnichalDetails.vue?vue&type=script&lang=js"
export * from "./RevisionTechnichalDetails.vue?vue&type=script&lang=js"
import style0 from "./RevisionTechnichalDetails.vue?vue&type=style&index=0&id=231524b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports